import * as React from "react";
import {Box} from "@mui/material";
// @ts-ignore
import {HorizontalMenu} from "../HorizontalMenu";
import {CompanyMenu} from "./CompanyMenu.ts";
import {JSX} from "react";

interface CompanyHorizontalMenuPanelProps {
    setMenuIx: (index: number) => void;
    isAdmin: boolean;
}

export const CompanyHorizontalMenuPanel: React.FC<CompanyHorizontalMenuPanelProps> = (
    {
        setMenuIx,
        isAdmin
    }
):JSX.Element => {
    return (
        <Box
            alignItems="flex-end"
            sx={{
                display: "flex",
                justifyContent: "center",
                "& > *": {
                    maxWidth: "800px",
                    minWidth: "800px",
                },
            }}
        >
            <HorizontalMenu
                menuList={CompanyMenu.arr}
                menuAdmin={CompanyMenu.admin}
                isAdmin={isAdmin}
                setMenuIx={(index: number):void => {
                    setMenuIx(index);
                }}
            />
        </Box>
    );
};
